import React, { createContext, useContext, useMemo } from "react";
import { getConfig, AppConfig } from "./appConfig";

const ConfigContext = createContext<AppConfig>(getConfig());

export const ConfigProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const value = useMemo(() => getConfig(), []);
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
